import { render } from "./DocuProject.vue?vue&type=template&id=2d9395e4&scoped=true"
import script from "./DocuProject.vue?vue&type=script&lang=js"
export * from "./DocuProject.vue?vue&type=script&lang=js"

import "./DocuProject.vue?vue&type=style&index=0&id=2d9395e4&scoped=true&lang=css"
import "./DocuProject.vue?vue&type=style&index=1&id=2d9395e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9395e4"]])

export default __exports__